"use strict";

exports.__esModule = true;
exports.UserTabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Icon = require("../../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Content(props) {
  const {
    data
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-l-userTabs__content__inner",
    children: data.text
  });
}

/**
 * Primary UI component for User Tabs
 */

const UserTabs = props => {
  const {
    data,
    config
  } = props;
  const {
    routerLocation = _reactRouterDom.useLocation,
    Link = _reactRouterDom.Link
  } = config;
  const {
    tabsData,
    content
  } = data;
  const {
    accountId,
    userId,
    tabs,
    labels
  } = tabsData;

  // backwards compatible.
  let location = routerLocation;
  if (typeof location === 'function') {
    location = location();
  }

  // fallback for when user list that passes tabs info has failed
  const emptyTab = {
    type: '',
    userId: '',
    firstName: '',
    lastName: ''
  };
  const users = tabs || [emptyTab];

  // which tab is active
  const [activeTab, setActiveTab] = (0, _react.useState)(0);
  const [activeUser, setActiveUser] = (0, _react.useState)(tabs ? tabs[0] : emptyTab);

  // show/hide the carer list
  const [activeDropdown, setActiveDropdown] = (0, _react.useState)(false);

  // set the active tab and content area to the click user based on id
  // update whether the dropdown is open/closed
  const handleActiveTab = tabData => {
    const {
      tabIndex
    } = tabData;
    config.callbackParent(tabIndex);
    setActiveTab(tabIndex);
    setActiveUser(tabData);
    setActiveDropdown(false);
  };
  const handleDropdown = () => {
    if (activeTab === 0) setActiveTab(-1);
    setActiveDropdown(!activeDropdown);
  };

  // update active tab and user based on query param if it exists
  (0, _react.useEffect)(() => {
    // check if we have more than one tab
    if (users.length > 1 && userId) {
      const userTab = users[userId];
      if (userTab) {
        return handleActiveTab(userTab);
      }
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);
  const tabsLayout = (t, l) => {
    var _location2;
    const numberOfTabs = t.length;
    const dropdownLength = numberOfTabs - 1;
    const disableLink = config == null ? void 0 : config.isLoading;
    /*
     * dont show tabs at all when there is only one user
     *
     */
    if (numberOfTabs === 1) {
      return null;
    }
    /*
     * show tabs side by side when there is a couple of users
     *
     */
    if (numberOfTabs === 2) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl-l-userTabs__tabs-row",
        children: t.map((tab, index) => {
          var _location;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `ccl-l-userTabs__tab ${
            // is this tab active?
            activeTab === tab.tabIndex ? 'ccl-l-userTabs__tab--is-active' : ''}`,
            "data-nw-tab": index + 1,
            "data-nw-tab-name": `${tab.firstName} ${tab.lastName}`,
            "data-nw-tab-usertype": tab.type,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Link, {
              onClick: e => disableLink ? e.preventDefault() : handleActiveTab(tab),
              to: disableLink ? '#' : `${(_location = location) == null ? void 0 : _location.pathname}?account=${accountId}&user=${tab.tabIndex}`,
              className: `ccl-l-userTabs__tab__button ${disableLink ? 'ccl-l-userTabs__tab__button--disabled' : ''}`,
              children: [tab.firstName, " ", tab.lastName, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "ccl-l-userTabs__tab__button__details is-hidden-mobile",
                children: tab.type
              })]
            })
          }, tab.tabIndex);
        })
      });
    }
    /*
     * more than 2 users, show primary tab and then a dropdown list in the other
     *
     */
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-l-userTabs__tabs-row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `ccl-l-userTabs__tab ${
        // is this tab active?
        activeTab === 0 ? 'ccl-l-userTabs__tab--is-active' : ''}`,
        "data-nw-tab": "1",
        "data-nw-tab-name": `${t[0].firstName} ${t[0].lastName}`,
        "data-nw-tab-usertype": t[0].type,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Link, {
          onClick: e => disableLink ? e.preventDefault() : handleActiveTab(t[0]),
          to: disableLink ? '#' : `${(_location2 = location) == null ? void 0 : _location2.pathname}?account=${accountId}&user=${t[0].tabIndex}`,
          className: `ccl-l-userTabs__tab__button ${disableLink ? 'ccl-l-userTabs__tab__button--disabled' : ''}`,
          children: [t[0].firstName, " ", t[0].lastName, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "ccl-l-userTabs__tab__button__details is-hidden-mobile",
            children: t[0].type
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `ccl-l-userTabs__tab ${
        // is this tab active?
        activeTab !== 0 ? 'ccl-l-userTabs__tab--is-active' : ''}`,
        "data-nw-tab": "2",
        "data-nw-tab-name": `${activeTab === 0 || activeTab === -1 ? '' : `${users[activeTab].firstName} ${users[activeTab].lastName}`}`,
        "data-nw-tab-number": dropdownLength,
        "data-nw-tab-usertype": l.type,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "ccl-l-userTabs__tab__button",
          onClick: () => handleDropdown(),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "ccl-l-userTabs__tab__button__label",
            children: activeTab === 0 || activeTab === -1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "ccl-l-userTabs__tab__prompt is-hidden-tablet",
                children: l.promptTextAbbrv
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "ccl-l-userTabs__tab__prompt is-hidden-mobile",
                children: l.promptText
              })]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "ccl-l-userTabs__tab__first-name",
                children: users[activeTab].firstName
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                className: "ccl-l-userTabs__tab__last-name is-hidden-mobile",
                children: [' ', users[activeTab].lastName]
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "ccl-l-userTabs__tab__button__details",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "ccl-l-userTabs__tab__button__details__length",
              children: dropdownLength
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: "ccl-l-userTabs__tab__button__details__type is-hidden-mobile",
              children: ["\xA0", l.type]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              color: "interactive",
              type: "expand-more",
              rotate: `${activeDropdown ? '180' : '0'}`
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: `ccl-l-userTabs__tab__list ${activeDropdown ? 'ccl-l-userTabs__tab__list--is-active' : ''}`,
          children: t.map(tab => {
            var _location3;
            if (tab.tabIndex === 0) return null;
            // loop through recipient list
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: `ccl-l-userTabs__tab__list__item ${
              // is this tab active?
              activeTab === tab.tabIndex ? 'ccl-l-userTabs__tab__list__item--is-active' : ''}`,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Link, {
                "data-nw-tab-list-option": tab.tabIndex,
                onClick: e => disableLink ? e.preventDefault() : handleActiveTab(tab),
                to: disableLink ? '#' : `${(_location3 = location) == null ? void 0 : _location3.pathname}?account=${accountId}&user=${tab.tabIndex}`,
                className: `ccl-l-userTabs__tab__list__item__button ${disableLink ? 'ccl-l-userTabs__tab__list__item__button--disabled' : ''}`,
                children: [tab.firstName, " ", tab.lastName, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  color: "interactive",
                  type: "chevron-right"
                })]
              })
            }, tab.tabIndex);
          })
        })]
      })]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `ccl-l-userTabs ${users.length === 1 ? 'ccl-l-userTabs--single' : ''}`,
    ...props,
    children: [tabsLayout(users, labels), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-l-userTabs__content",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
        ...props,
        data: content,
        activeTab: activeTab,
        activeUser: activeUser
      })
    })]
  });
};
exports.UserTabs = UserTabs;
UserTabs.defaultProps = {
  config: {
    isLoading: false,
    /* 
    A callback handler to the parent container when a tab user is changed
    */
    handleActiveTab: () => {},
    callbackParent: () => {}
  }
};